import "./debut.css"
import logoComin from "../images/logoComin.png"
import img1 from "../photo/un.jpg"
import img2 from "../photo/deux.jpg"
import img3 from "../photo/trois.jpg"
import img4 from "../photo/quatre.jpg"
import img5 from "../photo/cinq.jpg"


const Debut = (_) => {

    return (
        <div className="home">
            <div id="logo">
                <img src={logoComin} alt="logo cominboard"/>
            </div>
            <div id="rectangleHome">
                <div className="slideshow">
                    <ul>
                        <li><img src={img1} alt="Com'inboard"/></li>
                        <li><img src={img2} alt="Com'inboard"/></li>
                        <li><img src={img3} alt="Com'inboard"/></li>
                        <li><img src={img4} alt="Com'inboard"/></li>
                        <li><img src={img5} alt="Com'inboard"/></li>
                        {/* <li><img src={img6} alt="bateau"/></li>
                        <li><img src={img7} alt="bateau"/></li> */}
                    </ul>
                </div>
            </div>
            <div className="photoTel">
                <div className="photoSideLeft"></div>
                <div className="photoSideRight"></div>
            </div>
        </div>
    )
}

export default Debut